module.exports = __webpack_public_path__ + "static/img/index_wenhua1.aa31c55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_wenhua1.jpg
// module id = poM5
// module chunks = 1